import React from 'react';
import './SymptomBar.css';

const SymptomBar = ({ emoji, label, days, accentColor, pct, avgPct }) => (
  <div className="symptom-bar">
    <div className="symptom-bar__row">
      <span className="symptom-bar__emoji">{emoji}</span>
      <span className="symptom-bar__label">{label}</span>
      <span className="symptom-bar__days">{days} j</span>
    </div>
    <div className="symptom-bar__track">
      {avgPct != null && (
        <div className="symptom-bar__avg" style={{ width: `${avgPct}%`, background: accentColor + '33' }} />
      )}
      <div className="symptom-bar__fill" style={{ width: `${pct ?? 0}%`, background: accentColor }} />
    </div>
  </div>
);

export default SymptomBar;
